 if (window.innerWidth < 1024){

        $(document).ready(function() {
            tabMobileClick(1);
        })

        var activeLine =  $(".activeLineMobile");
        function tabMobileClick(index){
            $(".tabDivMobile").removeClass('activeTabMobile');
            var activeTab = $("#topNavTabMobile-"+index);
            activeTab.addClass('activeTabMobile');

            activeLine.css('width', $(".activeTabMobile .tabTextDivMobile").css('width'));
            activeLine.css('left', $(".activeTabMobile .tabTextDivMobile").position().left);
            changeTab(index);
        }

        function changeTab(index){
            switch (index){
                case 1:
                    $("#downloadBtnList-mobile").css('display','flex');
                    $(".customText-mobile").css('display',"none");
                    $(".productDocumentHelpMobileDiv").css('display',"none");
                    break;
                case 2:
                    $("#downloadBtnList-mobile").css('display','none');
                    $(".customText-mobile").css('display',"flex");
                    $(".productDocumentHelpMobileDiv").css('display',"flex");
                    break;
            }
        }

        $(window).resize(function() {
            activeLine.css('width',$(".activeTabMobile .tabTextDivMobile").css('width'));
            activeLine.css('left', $(".activeTabMobile").position().left );
        })

    }